import * as types from './mutation-types'
import storage from '@/utils/storage'
import { loginByAccount, logout } from '@/api/user'
import Cookies from 'js-cookie'
import vue from '../main'

export const loginByEmail = function({commit}, data) {
  return new Promise((resolve, reject) => {
    loginByAccount(data).then((res) => {
      const ret = res.data
      if(ret.code === '10001') {
        //将用户的信息存入localstorage
        const userObj = {
          uid: ret.data.uid,
          username: ret.data.username,
          is_check_email: ret.data.is_check_email,
          email: ret.data.email
        }
        Cookies.set('Admin-Token', ret.data.token) //将token存入cookie
        commit(types.SET_TOKEN, ret.data.token) // 将token存入vuex
        commit(types.SET_UID, ret.data.uid) // 用户id存入vuex
        storage.set('uid', ret.data.uid)
        commit(types.SET_USER, userObj) // 用户信息存入vuex
        storage.set('user', userObj) //用户信息存入storage
        resolve(ret.data)
      } else {
        vue.$message.error(ret.message)
        reject(ret.message)
      }
    }).catch((err) => {
      reject(err)
    })
  })
}

export const directLogin = function ({commit}, data) {
  return new Promise((resolve, reject) => {
    //将用户的信息存入localstorage
    const userObj = {
      uid: data.uid,
      username: data.username,
      is_check_email: data.is_check_email,
      email: data.email
    }
    Cookies.set('Admin-Token', data.token) //将token存入cookie
    commit(types.SET_TOKEN, data.token) // 将token存入vuex
    commit(types.SET_UID, data.uid) // 用户id存入vuex
    storage.set('uid', data.uid)
    commit(types.SET_USER, userObj) // 用户信息存入vuex
    storage.set('user', userObj) //用户信息存入storage
    resolve('10001')
  })
}

export const loginOut = function({commit, state}, data) {
  return new Promise ((resolve, reject) => {
    logout(data).then(res => {
      commit(types.SET_TOKEN, '')
      commit(types.SET_UID, '')
      commit(types.SET_USER, '')
      storage.set('uid', '')
      Cookies.remove('Admin-Token')
      storage.remove('user')
      storage.remove('uid')
      storage.remove('secret')
      resolve(res.data.message)
    }).catch(err => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/store/actions.js